
let startTop;
let scrollDom;

function adjustListener() {
    // 延时执行，等键盘弹出界面页面resize完成
    setTimeout(() => {
        let { top: elTop, height: elHeight } = this.getBoundingClientRect();
        let innerH = window.innerHeight;
        let compareH = elTop - innerH;
        scrollDom = findScrollDom(this);
        console.log('get scrollDom');
        console.log(scrollDom);
        if (scrollDom) {
            let style = window.getComputedStyle(scrollDom, null)
            let paddingBottomStr = style.getPropertyValue('padding-bottom');
            let transform = style.getPropertyValue('transform');
            let paddingBottom = parseInt(
                paddingBottomStr.substring(0, paddingBottomStr.length - 2)
            );
            let needScrollTop = compareH + elHeight + 100 + paddingBottom;
            console.log(`compareH = ${compareH}, -paddingBottom = ${-paddingBottom}`);
            if (compareH > -paddingBottom) {
                if (transform.startsWith('matrix')) {
                    let transformStrList = scrollDom.style.transform.split(' ');
                    let topStr = transformStrList[1];
                    startTop = topStr;
                    transformStrList[1] = `${Number(topStr.substring(0, topStr.length - 3)) - needScrollTop}px)`
                    scrollDom.style.transform = transformStrList.join(' ');
                    console.log('get scrollTop');
                    console.log(scrollDom.style.transform);
                } else {
                    startTop = scrollDom.scrollTop;
                    scrollDom.scrollTop += needScrollTop;
                    console.log('get scrollTop');
                    console.log(scrollDom.scrollTop);
                }
            }
        }
    }, 500);
}

function resetTop() {
    console.log('resetTop');
    let style = window.getComputedStyle(scrollDom, null)
    let transform = style.getPropertyValue('transform');
    if (startTop) {
        if (transform.startsWith('matrix')) {
            let transformStrList = scrollDom.style.transform.split(' ');
            transformStrList[1] = startTop;
            scrollDom.style.transform = transformStrList.join(' ');
            console.log('resetTop scrollTop = ' + scrollDom.style.transform);
        } else {
            scrollDom.scrollTop = startTop;
            console.log('resetTop scrollTop = ' + scrollDom.scrollTop);
        }
    }
}

function findScrollDom(dom) {
    let style = window.getComputedStyle(dom, null);
    let overflow = style.getPropertyValue('overflow');
    let overflowY = style.getPropertyValue('overflow-y');
    let transform = style.getPropertyValue('transform'); // "matrix(1, 0, 0, 1, 0, -100)"
    if (transform.startsWith('matrix')) {
        return dom;
    } else if (overflow === 'auto' || overflowY === 'auto') {
        return dom;
    } else if (dom.getAttribute('id') === 'app') {
        // 已经递归到页面的根节点，结束递归
        return null;
    } else {
        return findScrollDom(dom.parentNode);
    }
}

export default {
    bind(el, binding, vnode) {
        el.addEventListener('click', adjustListener, false);
    },
    unbind(el) {
        // resetTop();
        el.removeEventListener('click', adjustListener);
    }
};




// WEBPACK FOOTER //
// ./src/utils/keyboard.js